module.exports = __webpack_public_path__ + "img/searchGray2x.png?42a23ad6c4843794664cfc5cb912b52b";